<template>
  <div class="menu-popup">
    <slot/>
  </div>
</template>

<script>
import IconWallet from "@/components/icons/IconWallet";
import IconRoundTick from "@/components/icons/IconRoundTick";
export default {
name: "MenuPopup",
  components: {IconRoundTick, IconWallet}
}
</script>

<style lang="scss">
.menu-popup {
  @apply absolute right-0 -bottom-5 z-110 transform translate-y-full
  bg-block border border-border rounded w-full overflow-hidden;
}
</style>